module.exports = __webpack_public_path__ + "static/media/a-7.5c5a5b96.jpg";